/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionType } from './CompetitionType';
import {
    CompetitionTypeFromJSON,
    CompetitionTypeFromJSONTyped,
    CompetitionTypeToJSON,
    CompetitionTypeToJSONTyped,
} from './CompetitionType';

/**
 * For CHALLENGES section type on a Drop — narrows which competitions
 * render in the section. Sibling of HubSectionCompetitionFilter; kept
 * in lockstep. Single-field today (only `type` is observed); add new
 * fields explicitly as real consumers appear (no additionalProperties).
 * 
 * @export
 * @interface DropSectionCompetitionFilter
 */
export interface DropSectionCompetitionFilter {
    /**
     * 
     * @type {CompetitionType}
     * @memberof DropSectionCompetitionFilter
     */
    type?: CompetitionType;
}



/**
 * Check if a given object implements the DropSectionCompetitionFilter interface.
 */
export function instanceOfDropSectionCompetitionFilter(value: object): value is DropSectionCompetitionFilter {
    return true;
}

export function DropSectionCompetitionFilterFromJSON(json: any): DropSectionCompetitionFilter {
    return DropSectionCompetitionFilterFromJSONTyped(json, false);
}

export function DropSectionCompetitionFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropSectionCompetitionFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : CompetitionTypeFromJSON(json['type']),
    };
}

export function DropSectionCompetitionFilterToJSON(json: any): DropSectionCompetitionFilter {
    return DropSectionCompetitionFilterToJSONTyped(json, false);
}

export function DropSectionCompetitionFilterToJSONTyped(value?: DropSectionCompetitionFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': CompetitionTypeToJSON(value['type']),
    };
}

